
class Events {
  constructor(element) {

    /** @type {HTMLElement} */
    this.element = element;
  }

  /**
   * @template {AppEventKey} E
   * @param {E} type
   * @param {AppEventListener<E>} listener
   */
  addEventListener(type, listener) {
    this.element.addEventListener(type, listener);
  }

  /**
   * @template {AppEventKey} E
   * @overload
   * @param {E} type
   */

  /**
   *
   * @template {AppEventKey} E
   * @overload
   * @param {E} type
   * @param {AppEvent[E]} data
   */

  /**
   *
   * @template {AppEventKey} E
   * @param {E} type
   * @param {AppEvent[E]?} data
   */
  dispatchEvent(type, data = undefined) {
    const event = new CustomEvent(type, { detail: data });
    this.element.dispatchEvent(event);
  }

  /** 
   * @template {AppEventKey} E
   * @param {E} type
   * @param {AppEventListener<E>} listener
   */
  on(type, listener) {
    this.addEventListener(type, listener);
  }

  /**
   * @template {AppEventKey} E
   * @overload
   * @param {E} type
   * @return {Promise<E>}
   */

  /**
   * @template {AppEventKey} E
   * @template {AppEventListener<E> | never} L
   * @param {E} type
   * @param {L} [listener]
   * @return {L extends AppEventListener<E> ? void : Promise<CustomEvent<E>>}
   */
  once(type, listener = undefined) {
    const self = this;

    if (listener) {
      this.on(type, function g() {
        self.removeEventListener(type, g);
        listener.apply(this, arguments);
      });
    }
    else {
      // @ts-ignore Dunno how to define return type because conditional type
      return new Promise((resolve) => {
        self.on(type, /** @type {AppEventListener<E>} */ function g(event) {
          self.removeEventListener(type, g);
          resolve(event);
        });
      });
    }
  }

  /**
   * @template {AppEventKey} E
   * @param {E} type
   * @param {AppEventListener<E>} listener
   */
  removeEventListener(type, listener) {
    this.element.removeEventListener(type, listener);
  }
}


const instance = new Events(document.body);

export default instance;
